<template>
	<div class="page">
		<NavBar
			title="价格走势"
			:right-text="currentAction.name"
			left-arrow
			@click-left="onClickLeft"
			@click-right="onClickRight"
		/>
		<div class="trend-card">
			<Cell :border="false">
			  <div class="box">
				  <VanImage
					  width="3rem"
					  height="3rem"
					  class="box-left"
					  :src="data.marketImages && data.marketImages[0] && data.marketImages[0].imageUrl"/>
				  <div class="box-right">
					  <p class="title">{{ data.marketInfo && data.marketInfo.marketName }}</p>
					  <p class="text"><span>其他描述信息，开发中...</span></p>
				  </div>

			  </div>
		  </Cell>
			<div class="chart-line">
			  <div class="chart" ref="line"></div>
		  </div>
		</div>
		<ActionSheet v-model="show" :actions="actions" @select="onSelect" />
	</div>
</template>

<script>
	import {  NavBar, Image as VanImage, Cell, Button, ActionSheet  } from 'vant';
  import echarts from 'echarts';
  import moment from 'moment';

	export default {
    components: {NavBar, VanImage, Cell, Button, ActionSheet },
		data() {
      const cur = moment().format('YYYY-MM-DD');
      return {
        data: {},
        show: false,
        actions: [
          { name: '最近一周', value: [moment(cur).subtract(7, 'days').valueOf(),moment(cur).valueOf()] },
          { name: '最近一月', value: [moment(cur).subtract(1, 'month').valueOf(),moment(cur).valueOf()] },
          { name: '最近三月', value: [moment(cur).subtract(3, 'month').valueOf(),moment(cur).valueOf()] },
          { name: '最近半年', value: [moment(cur).subtract(6, 'month').valueOf(),moment(cur).valueOf()] },
          { name: '最近一年', value: [moment(cur).subtract(12, 'month').valueOf(),moment(cur).valueOf()] }
        ],
        currentAction: {}
      }
		},
		async created() {
			this.data = this.$route.params;
      this.currentAction = this.actions[0];
      const [ sTime, eTime ] = this.actions[0].value;
      const { rows } = await this.$store.dispatch('fetchMarketPrice', { marketId: this.data.marketInfo.id, start: moment(sTime).format('YYYY-MM-DD'), end: moment(eTime).format('YYYY-MM-DD')});
      this.data.marketPrices = rows;
			this.initChart();
		},
		methods: {
      onSelect(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        const [ sTime, eTime ] = item.value;
        this.currentAction = item;
        this.show = false;

        this.refreshData(sTime,eTime);

      },
      onClickLeft() {
        this.$router.back();
      },
      onClickRight() {
        this.show = true;
      },
			async refreshData(sTime,eTime) {
        const { rows } = await this.$store.dispatch('fetchMarketPrice', { marketId: this.data.marketInfo.id, start: moment(sTime).format('YYYY-MM-DD'), end: moment(eTime).format('YYYY-MM-DD')});
        this.data.marketPrices = rows;
        this.initChart();
			},
			initChart() {
        const that = this
        const marketPrices = this.data.marketPrices;
        let maxPrice = 0
        let minPrice = (marketPrices[0] && marketPrices[0].price) || 0
        const xAxisData = marketPrices.map(v => {
          const day = v['dateDay'].split('-')[2];
          return `${day}号`;
        })
        const seriesData = marketPrices.map(v => {
          if (maxPrice < v['price']) {
            maxPrice = v['price']
          }
          if (minPrice > v['price']) {
            minPrice = v['price']
          }
          return v['price'];
        })
        const colors = ['#ee0a24', '#d14a61', '#675bba'];
        const myChart = echarts.init(this.$refs.line);
        myChart.setOption({
          color: colors,
          grid: {
            left: 60,
            top: 10,
            bottom: 30
          },
          tooltip: {
            trigger: 'axis',
            formatter: function (params, ticket, callback) {
              return that.data.marketPrices[params[0].dataIndex].dateDay + '：<br/>' + params[0].value + '元';
            }
          },
          xAxis: {
            data: xAxisData
          },
          yAxis: {
            min: minPrice,
            max: maxPrice
          },
          series: [{
            name: '数据',
            type: 'line',
            data: seriesData
          }]
        });
        setTimeout(p => {
          myChart.dispatchAction({
            type: 'showTip',
            seriesIndex:0,  // 显示第几个series
            dataIndex: that.data.marketPrices.length - 1 // 显示第几个数据
          });
        }, 10)
			}
		}
	}
</script>

<style lang="less" scoped>

	.chart {
		width: 375px;
		height: 160px;
	}
</style>
